export const igrac = {
  ime: null,
  jedinica: 'Valjevski partizanski odred',
  pol: null,
  strana: null,
  bitke: [],
  poena: 0,
  ubioNemaca: 0,
  ubioItalijana: 0,
  ubioUstasa: 0,
  ubioChetnika: 0,
  ubioPartizana: 0,
  ubioCivila: 0,
  poginuo: 0,
  odlikovanja: []
}



// WEBPACK FOOTER //
// ./src/igrac.js